// src/constants/tasks.js
// Constantes relacionadas a Tarefas (Tasks) / Operacional / CRM

import { getOptionsFromMap } from './common';

export const TASK_STATUS = {
    NEW: 'new',
    SCHEDULED: 'scheduled',
    DOING: 'doing',
    WAITING: 'waiting',
    OVERDUE: 'overdue',
    DONE: 'done',
    ARCHIVED: 'archived'
};

export const TASK_STATUS_LABELS = {
    [TASK_STATUS.NEW]: 'Para Contatar',
    [TASK_STATUS.SCHEDULED]: 'Programado',
    [TASK_STATUS.DOING]: 'Fazendo',
    [TASK_STATUS.WAITING]: 'Aguardando Retorno',
    [TASK_STATUS.OVERDUE]: 'Atrasado',
    [TASK_STATUS.DONE]: 'Concluído',
    [TASK_STATUS.ARCHIVED]: 'Arquivado'
};

export const TASK_PRIORITY = {
    LOW: 'low',
    NORMAL: 'normal',
    HIGH: 'high',
};

export const TASK_PRIORITY_LABELS = {
    [TASK_PRIORITY.LOW]: 'Baixa',
    [TASK_PRIORITY.NORMAL]: 'Média / Normal',
    [TASK_PRIORITY.HIGH]: 'Alta / Urgente',
};

export const TASK_TYPE = {
    CONTACT: 'contact',
    TECHNICAL: 'technical',
    FINANCIAL: 'financial',
    MAINTENANCE: 'maintenance',
    INTERNAL: 'internal',
};

export const TASK_TYPE_LABELS = {
    [TASK_TYPE.CONTACT]: 'CRM / Contato',
    [TASK_TYPE.TECHNICAL]: 'Professores / Técnico',
    [TASK_TYPE.FINANCIAL]: 'Financeiro / Administrativo',
    [TASK_TYPE.MAINTENANCE]: 'Manutenção de Estrutura',
    [TASK_TYPE.INTERNAL]: 'Gestão / Interno',
};

// ═══ CRM: Motivo do Contato ═══
export const CONTACT_REASON = {
    RENEWAL: 'renewal',
    REACTIVATION: 'reactivation',
    RETENTION: 'retention',
    BILLING: 'billing',
    TRIAL_FOLLOWUP: 'trial_followup',
    DEADLINE_REQUEST: 'deadline_request',
    FREEZE_REQUEST: 'freeze_request',
    REFERRAL: 'referral',
    UPGRADE: 'upgrade',
    COMPLAINT: 'complaint',
    WAITLIST_AVAILABLE: 'waitlist_available',
    OTHER: 'other',
};

export const CONTACT_REASON_LABELS = {
    [CONTACT_REASON.RENEWAL]: 'Renovação',
    [CONTACT_REASON.REACTIVATION]: 'Reativação',
    [CONTACT_REASON.RETENTION]: 'Resgate / Retenção',
    [CONTACT_REASON.BILLING]: 'Cobrança',
    [CONTACT_REASON.TRIAL_FOLLOWUP]: 'Experimental',
    [CONTACT_REASON.DEADLINE_REQUEST]: 'Pediu Prazo',
    [CONTACT_REASON.FREEZE_REQUEST]: 'Trancamento',
    [CONTACT_REASON.REFERRAL]: 'Indicação',
    [CONTACT_REASON.UPGRADE]: 'Upgrade',
    [CONTACT_REASON.COMPLAINT]: 'Reclamação',
    [CONTACT_REASON.WAITLIST_AVAILABLE]: 'Vaga Disponível (Lista de Espera)',
    [CONTACT_REASON.OTHER]: 'Outro',
};

/** Mapa de ícone MDI + cor para renderização visual dos motivos */
export const CONTACT_REASON_ICONS = {
    [CONTACT_REASON.RENEWAL]: { icon: 'mdi-autorenew', color: 'primary' },
    [CONTACT_REASON.REACTIVATION]: { icon: 'mdi-account-reactivate', color: 'info' },
    [CONTACT_REASON.RETENTION]: { icon: 'mdi-shield-account-outline', color: 'warning' },
    [CONTACT_REASON.BILLING]: { icon: 'mdi-calendar-clock', color: 'danger' },
    [CONTACT_REASON.TRIAL_FOLLOWUP]: { icon: 'mdi-calendar-clock-outline', color: 'success' },
    [CONTACT_REASON.DEADLINE_REQUEST]: { icon: 'mdi-clock-alert-outline', color: 'warning' },
    [CONTACT_REASON.FREEZE_REQUEST]: { icon: 'mdi-pause-circle-outline', color: 'secondary' },
    [CONTACT_REASON.REFERRAL]: { icon: 'mdi-account-plus-outline', color: 'info' },
    [CONTACT_REASON.UPGRADE]: { icon: 'mdi-arrow-up-bold-circle-outline', color: 'primary' },
    [CONTACT_REASON.COMPLAINT]: { icon: 'mdi-alert-outline', color: 'danger' },
    [CONTACT_REASON.WAITLIST_AVAILABLE]: { icon: 'mdi-account-clock-outline', color: 'success' },
    [CONTACT_REASON.OTHER]: { icon: 'mdi-text-box-outline', color: 'secondary' },
};

// ═══ CRM: Resultado do Contato ═══
export const CONTACT_OUTCOME = {
    ENROLLED: 'enrolled',
    RENEWED: 'renewed',
    RETAINED: 'retained',
    PAID: 'paid',
    RESOLVED: 'resolved',
    FROZEN: 'frozen',
    NO_ANSWER: 'no_answer',
    ASKED_DEADLINE: 'asked_deadline',
    GAVE_UP: 'gave_up',
    SCHEDULED_VISIT: 'scheduled_visit',
    REQUESTED_DISCOUNT: 'requested_discount',
    CALLBACK_LATER: 'callback_later',
    NO_RESPONSE_ARCHIVED: 'no_response_archived',
    // Funil de experimental
    TRIAL_SCHEDULED: 'trial_scheduled',
    TRIAL_CONFIRMED: 'trial_confirmed',
};

export const CONTACT_OUTCOME_LABELS = {
    [CONTACT_OUTCOME.ENROLLED]: 'Matriculou',
    [CONTACT_OUTCOME.RENEWED]: 'Renovou',
    [CONTACT_OUTCOME.RETAINED]: 'Resgatou / Reteve',
    [CONTACT_OUTCOME.PAID]: 'Pagou / Quitou',
    [CONTACT_OUTCOME.RESOLVED]: 'Resolvido',
    [CONTACT_OUTCOME.FROZEN]: 'Trancou Matrícula',
    [CONTACT_OUTCOME.NO_ANSWER]: 'Não Atendeu',
    [CONTACT_OUTCOME.ASKED_DEADLINE]: 'Pediu Prazo',
    [CONTACT_OUTCOME.GAVE_UP]: 'Desistiu',
    [CONTACT_OUTCOME.SCHEDULED_VISIT]: 'Agendou Visita',
    [CONTACT_OUTCOME.REQUESTED_DISCOUNT]: 'Pediu Desconto',
    [CONTACT_OUTCOME.CALLBACK_LATER]: 'Retornar Depois',
    [CONTACT_OUTCOME.NO_RESPONSE_ARCHIVED]: 'Sem Resposta / Inatividade',
    [CONTACT_OUTCOME.TRIAL_SCHEDULED]: 'Agendou Aula Experimental',
    [CONTACT_OUTCOME.TRIAL_CONFIRMED]: 'Confirmou Presença na Experimental',
};

/** Mapa de ícone MDI + cor para renderização visual dos resultados */
export const CONTACT_OUTCOME_ICONS = {
    [CONTACT_OUTCOME.ENROLLED]: { icon: 'mdi-check-circle', color: 'success' },
    [CONTACT_OUTCOME.RENEWED]: { icon: 'mdi-check-circle', color: 'success' },
    [CONTACT_OUTCOME.RETAINED]: { icon: 'mdi-shield-check', color: 'success' },
    [CONTACT_OUTCOME.PAID]: { icon: 'mdi-cash-check', color: 'success' },
    [CONTACT_OUTCOME.RESOLVED]: { icon: 'mdi-check-decagram', color: 'success' },
    [CONTACT_OUTCOME.FROZEN]: { icon: 'mdi-pause-circle', color: 'secondary' },
    [CONTACT_OUTCOME.NO_ANSWER]: { icon: 'mdi-phone-missed', color: 'danger' },
    [CONTACT_OUTCOME.ASKED_DEADLINE]: { icon: 'mdi-clock-outline', color: 'warning' },
    [CONTACT_OUTCOME.GAVE_UP]: { icon: 'mdi-close-circle', color: 'danger' },
    [CONTACT_OUTCOME.SCHEDULED_VISIT]: { icon: 'mdi-calendar-check', color: 'info' },
    [CONTACT_OUTCOME.REQUESTED_DISCOUNT]: { icon: 'mdi-tag-outline', color: 'warning' },
    [CONTACT_OUTCOME.CALLBACK_LATER]: { icon: 'mdi-phone-return-outline', color: 'info' },
    [CONTACT_OUTCOME.NO_RESPONSE_ARCHIVED]: { icon: 'mdi-account-off-outline', color: 'secondary' },
    [CONTACT_OUTCOME.TRIAL_SCHEDULED]: { icon: 'mdi-calendar-plus', color: 'success' },
    [CONTACT_OUTCOME.TRIAL_CONFIRMED]: { icon: 'mdi-calendar-check', color: 'success' },
};

// ═══ CRM: Motivo de Perda ═══
export const LOSS_REASON = {
    PRICE: 'price',
    LOCATION: 'location',
    SCHEDULE: 'schedule',
    COMPETITOR: 'competitor',
    HEALTH: 'health',
    UNKNOWN: 'unknown',
};

export const LOSS_REASON_LABELS = {
    [LOSS_REASON.PRICE]: 'Preço / Financeiro',
    [LOSS_REASON.LOCATION]: 'Localização / Distância',
    [LOSS_REASON.SCHEDULE]: 'Horário Incompatível',
    [LOSS_REASON.COMPETITOR]: 'Foi para Concorrente',
    [LOSS_REASON.HEALTH]: 'Problema de Saúde',
    [LOSS_REASON.UNKNOWN]: 'Não informou',
};

// Funções utilitárias herdadas para popular dropdowns e options
export const TASK_STATUS_OPTIONS = getOptionsFromMap(TASK_STATUS, TASK_STATUS_LABELS);
export const TASK_PRIORITY_OPTIONS = getOptionsFromMap(TASK_PRIORITY, TASK_PRIORITY_LABELS);
export const TASK_TYPE_OPTIONS = getOptionsFromMap(TASK_TYPE, TASK_TYPE_LABELS);
export const CONTACT_REASON_OPTIONS = getOptionsFromMap(CONTACT_REASON, CONTACT_REASON_LABELS);
export const CONTACT_OUTCOME_OPTIONS = getOptionsFromMap(CONTACT_OUTCOME, CONTACT_OUTCOME_LABELS);
export const LOSS_REASON_OPTIONS = getOptionsFromMap(LOSS_REASON, LOSS_REASON_LABELS);

